import { initFeatureFlags } from "common/feature-flags";
import { defined } from "common/Support";
import { load, save } from "common/storage";

export function initFeatureFlagsWithStorage(): void {
    initFeatureFlags({ load: (k, v) => defined(load(k, v, v)), save }, (name, value) => {
        (window as any)[name] = value;
    });
}
